import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteGratuitoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='GRATUITO' htmlFor='input-importeGratuito' md={6} alignRightAt='md' />
      <Col md={6}>
        <Form.InputNumber id='input-importeGratuito' name='input-importeGratuito' value={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteGratuitoFormGroup)
